export interface Pn18FromUrl {
  readonly pn18?: string;
  readonly addToCart?: boolean;

  /**
   * Support for wrongly encoded campaign search params that are part of the
   * "linecode" param.
   */
  readonly lineCodeCampaignSearch?: string;
}

export function getPn18FromUrl(
  searchParams: URLSearchParams,
  defaultPn18PerLineCode: Record<string, string>,
): Pn18FromUrl {
  const pn18Param = searchParams.get(`pn18`);
  const addToCartParam = searchParams.get(`addToCart`);
  const addToCart = addToCartParam === `true` || addToCartParam === ``;

  if (pn18Param) {
    return {pn18: pn18Param, addToCart};
  }

  const [lineCode, lineCodeCampaignSearch] = decodeURIComponent(
    searchParams.get(`lineCode`) ?? searchParams.get(`linecode`) ?? ``,
  ).split(`?`);

  const pn18 = lineCode && defaultPn18PerLineCode[lineCode];

  return {pn18, addToCart, lineCodeCampaignSearch};
}
